import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function EssencialOils(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual Finalidade?</span>
          </th>
          <th>
            <span>Qual Dose?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.pre.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.initial.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 1</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 2</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth2.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth2.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.growth2.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Final</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.final.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.final.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.essencialOils.final.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
